import { createContext, FC, ReactNode, useContext } from 'react';
import { ResolutionResult, useWorkspaceResolution } from '../hooks/useWorkspaceResolution';

const WorkspaceResolutionContext = createContext<ResolutionResult | null>(null);

export const WorkspaceResolutionProvider: FC<{
    children: ReactNode;
}> = ({ children }) => {
    const resolution = useWorkspaceResolution({ mode: 'home' });

    return (
        <WorkspaceResolutionContext.Provider value={resolution}>
            {children}
        </WorkspaceResolutionContext.Provider>
    );
};

export function useHomeWorkspaceResolution(): ResolutionResult {
    const ctx = useContext(WorkspaceResolutionContext);
    if (ctx === null) {
        throw new Error('useHomeWorkspaceResolution must be used inside context provider');
    }
    return ctx;
}
